import Vue from 'vue'
import Vuex from 'vuex'
import {getRongCloudToken} from "../utils/interface";
import * as RongIMLib from "@rongcloud/imlib-next";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    routerPath: '',
    allPark: true,
    isTokenDoor: false, // 请求回来变为true
    isLogin: false,
    isUsermessage: {},
    chatRecord:{},
    isChatting: false,
    unReadMsgCount: 0,
    status:'',
    vrUrlState:'',
	  share_con:false,
    compare: [], // 产品对比
    checkList: [], //选中的
  },
  mutations: {
    routerPathVuex(state, val) {
      return state.routerPath = val;
    },
    vuexAllPark(state, val){
      state.allPark = val
    },
    isTokenDoorVuex(state, val){
      state.isTokenDoor = val
    },
    // 登录后
    isLoginVuex(state, val){
      state.isLogin = val
    },
    //存储文档信息
    isuserServeVuex(state, val){
      console.log(val)
      state.status = val
    },
    // 储存用户信息
    isStorageUsermessage(state, val){
      state.isUsermessage = val;
      getRongCloudToken({
        userId: val.uuid,
        userName: val.name,
        userPhoto: val.headUrl
      }).then((res) => {
        state.rongCloudToken = res.data;
        //连接融云
        let token = res.data;
        RongIMLib.connect(token).then(res => {
          if (res.code === 0) {
            console.log('当前用户：---'+res.data.userId)
            //获取会话未读数
            const includeMuted = false
            const conversationTypes = [RongIMLib.ConversationType.PRIVATE]
            RongIMLib.getTotalUnreadCount(includeMuted, conversationTypes).then(res => {
              if (res.code === 0) {
                this.state.unReadMsgCount = res.data
              } else {
                console.log(res.code, res.msg)
              }
            }).catch(error => {
              console.log(error)
            })
          }
        });
      })
    },

    isChattingVuex(state, val){
      state.isChatting = val
    },
    isShare_con(state, val){
      state.share_con = val
    },
    clearChatRecords(state,val) {
      state.chatRecord[val] = [];
    },
    // 储存vrUrl
    vrUrlMutations(state, val){
      state.vrUrlState = val
    },
    // 储存产品对比数据
    compareVuex(state, val){
      state.compare = val
    },
    // 储存产品对比数据 选中的
    checkListVuex(state, val){
      state.checkList = val
    }
  },
  /* vuex数据持久化配置 */
  plugins: [
    createPersistedState({
      // 存储方式：localStorage、sessionStorage、cookies
      storage: window.localStorage,
    })
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js